import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RedirectIfAuthenticated = ({ redirectTo }) => {
    const user = useSelector((state) => state.user.user);
    const location = useLocation();
    let to = redirectTo;

    if (location.state?.from && !location.state.from.pathname.includes('logout')) {
        to = location.state.from.pathname;
    }

    return user ? <Navigate to={to} state={{ from: location }} replace /> : <Outlet />;
};
export default RedirectIfAuthenticated;
